"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var react_individual_character_input_boxes_1 = __importDefault(require("react-individual-character-input-boxes"));
var next_intl_1 = require("next-intl");
var FilledPhone_1 = __importDefault(require("../FilledPhone"));
var Resend_1 = __importDefault(require("../Resend"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var symbolCount = 6;
var CodeVerify = function (_a) {
    var phone = _a.phone, setNextStep = _a.setNextStep, setCanEditPhone = _a.setCanEditPhone, tempToken = _a.tempToken, setTmpResetToken = _a.setTmpResetToken, setResetPassToken = _a.setResetPassToken;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tReset = (0, next_intl_1.useTranslations)('resetPassword');
    var tPhone = (0, next_intl_1.useTranslations)('phoneVerification');
    var _b = (0, react_1.useState)(false), errorDisabled = _b[0], setErrorDisabled = _b[1];
    var _c = (0, react_1.useState)(''), code = _c[0], setCode = _c[1];
    var _d = (0, react_1.useState)(undefined), error = _d[0], setError = _d[1];
    var _e = (0, swr_hooks_1.useVerifyCode)({
        successAction: function (data) {
            setNextStep();
            setResetPassToken(data);
        },
        errorAction: function (err) {
            setError(err);
        },
    }), verifyCode = _e.verifyCode, isSubmitting = _e.isSubmitting;
    var verifyCodeHandler = (0, react_1.useCallback)(function () {
        if (!tempToken)
            return setError('invalid');
        verifyCode({ tempToken: tempToken, code: code });
        //eslint-disable-next-line
    }, [tempToken, code]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(ui_components_1.ModalTitle, null,
            react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: tReset('passwordReset'),
                } })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, tReset('weSentCodeToYourPhoneNumberViaSMS')),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, tPhone('pleaseEnterItBelow')),
            react_1.default.createElement(react_individual_character_input_boxes_1.default, { handleOutputString: function (string) {
                    setCode(string);
                    setErrorDisabled(false);
                }, amount: symbolCount, autoFocus: false, inputRegExp: /^[0-9]$/, inputProps: {
                    className: "".concat(styles_module_scss_1.default.field, " ").concat(error ? styles_module_scss_1.default.fieldError : ''),
                    inputmode: 'numeric',
                    type: 'tel',
                    pattern: '[0-9]*',
                } })),
        react_1.default.createElement(FilledPhone_1.default, { setCanEditPhone: function () {
                setCanEditPhone(true);
            }, phone: "+".concat(phone) }),
        react_1.default.createElement(Resend_1.default, { error: error, phone: phone, setTmpResetToken: setTmpResetToken }),
        react_1.default.createElement(ui_components_1.FixedButton, { height: "40px", width: "100%", type: "button", text: "upper", color: "gradient", loading: isSubmitting, maxWidth: "none", onClick: verifyCodeHandler, disabled: code.length < 6 || errorDisabled }, t('confirm'))));
};
exports.default = CodeVerify;
